document.addEventListener('DOMContentLoaded', function() { 
    ajustHeader();

    $(window).on("load resize", function(){
        ajustHeader();
    });

    window.addEventListener("pageshow", function(evt){
      if(isMacOS() && (evt.persisted || performance.navigation.type == 2)){            
        window.location.reload();  
      }
    }, false);
    
  });
    
  function isMacOS() {
    return navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i)? true : false;
  }
  
  function ajustHeader(){
    var welcomeHeight = $('.w-announcements').outerHeight();
    var headerHeight = $('.header-section').outerHeight();
    $('.header-section').css('top', welcomeHeight);
    $('.menu-drawer').css('top', welcomeHeight + headerHeight);
    $('.content-for-layout').css('padding-top', welcomeHeight + headerHeight);
  }